/**
 * ModulePlaceholder.jsx
 * Placeholder component for modules not yet implemented
 * Shows a warm, encouraging "Coming Soon" message
 */

import { useNavigate } from "react-router-dom";
import { ArrowLeft, Clock, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import CustomerLayout from "./CustomerLayout";

const ModulePlaceholder = ({ 
  title = "Coming Soon",
  description = "We're putting the finishing touches on this feature.",
  icon: Icon = Clock
}) => {
  const navigate = useNavigate();
  
  // Get customer and wedding data from localStorage
  const customer = JSON.parse(localStorage.getItem("customer_data") || "{}");
  const wedding = JSON.parse(localStorage.getItem("wedding_data") || "{}");

  return (
    <CustomerLayout customer={customer} wedding={wedding}>
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center max-w-md mx-auto px-4">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-[#C9A87C]/20 to-[#D4B896]/20 mb-6">
            <Icon className="w-10 h-10 text-[#C9A87C]" />
          </div>
          
          {/* Title */}
          <h1 className="text-2xl sm:text-3xl font-serif text-[#5C4A3D] mb-3">
            {title}
          </h1>
          
          {/* Description */}
          <p className="text-[#8B7355] mb-6">
            {description}
          </p>
          
          {/* Reassuring message */}
          <div className="bg-[#C9A87C]/10 rounded-2xl p-4 mb-6">
            <div className="flex items-center justify-center gap-2 text-[#8B6914]">
              <Heart className="w-4 h-4" />
              <span className="text-sm font-medium">
                Our team will guide you through this when ready
              </span>
            </div>
          </div>
          
          {/* Back button */}
          <Button
            onClick={() => navigate("/my-wedding/dashboard")}
            variant="outline"
            className="border-[#C9A87C] text-[#8B6914] hover:bg-[#C9A87C]/10"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </Button>
        </div>
      </div>
    </CustomerLayout>
  );
};

// Export specific module placeholders
export const FoodMenuPage = () => (
  <ModulePlaceholder 
    title="Food & Menu"
    description="Soon you'll be able to curate the perfect dining experience for your guests, selecting meals day-wise and adding your special preferences."
  />
);

export const RoomAllocationPage = () => (
  <ModulePlaceholder 
    title="Room Allocation"
    description="This feature will let you assign rooms to your family and guests, ensuring everyone has a comfortable stay."
  />
);

export const ItineraryPage = () => (
  <ModulePlaceholder 
    title="Event Itinerary"
    description="Plan the perfect flow for your celebration - from welcome ceremonies to the final farewell."
  />
);

export const InvitePageBuilder = () => (
  <ModulePlaceholder 
    title="Wedding Invite Page"
    description="Create a beautiful digital invitation for your guests with your photos, story, and RSVP functionality."
  />
);

export const DecorPage = () => (
  <ModulePlaceholder 
    title="Decor & Styling"
    description="Finalize the look and feel of your venue with our curated decor options and personalization choices."
  />
);

export default ModulePlaceholder;
